"use client";

import { Facebook, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Footer() {
  const socialLinks = [{
    id: "1",
    href: "https://facebook.com",
    icon: Facebook,
    label: "Facebook"
  }, {
    id: "2",
    href: "https://linkedin.com",
    icon: Linkedin,
    label: "LinkedIn"
  }, {
    id: "3",
    href: "https://twitter.com",
    icon: Twitter,
    label: "Twitter"
  }];
  return <footer className="bg-background border-t border-border-strong">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row sm:justify-between">
          {}
          <div className="flex-shrink-0 order-2 sm:order-1">
            <Link to="/" aria-label="Nhật Minh Khang & Partners Co., Ltd. Home">
              <img src="https://nhatminhkhang.com/wp-content/uploads/2026/01/Artboard-1-copy@2x-100-0123.png" alt="Nhật Minh Khang & Partners Co., Ltd." className="h-10" />
            </Link>
          </div>

          {}
          <div className="flex items-center gap-4 order-1 sm:order-2">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.id} to={social.href} newTab aria-label={social.label} data-index={i} className="group relative text-primary hover:text-accent-dark transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
                  <Icon className="size-5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:scale-110" />
                  <span className="absolute inset-0 rounded-full border-2 border-transparent group-hover:border-accent opacity-0 group-hover:opacity-100 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] scale-110 group-hover:scale-125" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}